<template>
    <v-dialog
        v-model="showDialog"
        max-width="960"
        persistent
        class="edit-email flex-none"
    >
        <template #activator="{ on }">
            <div v-on="on" class="edit-email-activator" style="width: 100%">
                <v-tooltip bottom v-if="alternativeBtn">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            @click="show()"
                            v-bind="$attrs"
                            class="drei_60-btn mb-2"
                            block
                        >
                            Login/Email bearbeiten
                        </v-btn>
                    </template>
                    <div class="max-width-btn">
                        Bearbeiten der Email-Adresse. Achtung: Damit wird auch der Login des Benutzer geändert.
                    </div>
                </v-tooltip>
                <v-tooltip left v-if="!alternativeBtn">
                    <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            @click="show()"
                            v-bind="$attrs"
                            text
                            icon
                            class="drei_60-black-text"
                        >
                            <v-icon v-bind="$attrs">mdi-email-edit</v-icon>
                        </v-btn>
                    </template>
                    <span>Login/Email bearbeiten</span>
                </v-tooltip>
            </div>
        </template>
        <v-card>
            <v-card-title
                class="headline"
                primary-title
            >
                Login/Email bearbeiten
            </v-card-title>
            <v-card-text v-if="loading">
                <v-container d-flex align-center justify-center>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
            </v-card-text>
            <v-card-text v-if="!loading">
                <div class="customer-edit-email">
                    <v-layout>
                        <v-flex md12 wrap mb-4 mt-4>
                            <b>Achtung:</b> Mit der Änderung der Email-Adresse ändert sich auch der Login des Benutzers.
                        </v-flex>
                    </v-layout>
                    <v-layout wrap mb-4>
                        <v-flex md6 pr-1>
                            <LabelValue label="Name" :value="fullname"/>
                        </v-flex>
                        <v-flex md6 pl-1>
                            <LabelValue label="Bisherige Email" :value="emailOld"/>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap mb-2>
                        <v-flex md12>
                            <v-stepper vertical v-model="this.step" class="customer-edit-wizard">
                                <v-stepper-step
                                    step="1"
                                    :complete="this.step > 1"
                                    edit-icon="$complete"
                                    color="success"
                                    editable>
                                    <div class="customer-edit-wizard-step-label">
                                        <div>
                                            Neue Email eingeben
                                        </div>
                                        <div v-if="this.checkedEmail !== '' && this.step === 2">
                                            Eingegebene Email: <b>{{ this.checkedEmail }}</b>
                                        </div>
                                    </div>
                                </v-stepper-step>
                                <v-stepper-content step="1">
                                    <div class="edit-email-stepper-content">
                                        <v-form v-model="valid" v-on:submit.prevent>
                                            <v-text-field
                                                :value="email"
                                                @input="setEmail"
                                                :rules="emailRules"
                                                :disabled="loading && loadingSystems"
                                                @keyup.enter="check"
                                                label="Neue E-Mailadresse"
                                            ></v-text-field>
                                        </v-form>
                                        <div class="edit-email-stepper-content-actions">
                                            <v-btn
                                                color="success"
                                                outlined
                                                :disabled="!valid || loadingSystems"
                                                :loading="loadingSystems"
                                                @click="check"
                                            >
                                                Prüfen
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-stepper-content>
                                <v-stepper-step step="2" :complete="this.step > 2" edit-icon="$complete" color="success">
                                    Systeme auswählen
                                </v-stepper-step>
                                <v-stepper-content step="2">
                                    <div class="edit-email-stepper-content">
                                        <KeineDaten v-if="loadingSystems"></KeineDaten>
                                        <template v-if="!loadingSystems">
                                            <div v-for="(item, index) in systems" :key="index">
                                                <p v-if="item.system == 'Celeraone' && !item.updateable" class="alert alert-info">
                                                    Diese E-Mail ist in CeleraOne schon mit der ID {{ item.id }} verknüpft.
                                                </p>
                                            </div>
                                        </template>
                                        <v-simple-table v-if="!loadingSystems">
                                            <template v-slot:default>
                                                <thead>
                                                    <th>Update</th>
                                                    <th>System</th>
                                                    <th>ID</th>
                                                    <th>Vorname</th>
                                                    <th>Nachname</th>
                                                    <th>E-Mail</th>
                                                    <th></th>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(item, index) in systems" :key="index">
                                                    <td><v-simple-checkbox v-model="item.selected" :disabled="!item.updateable" :ripple="false"></v-simple-checkbox></td>
                                                    <td>{{ item.system + " " + (item.scope !== null ? item.scope : "") }}</td>
                                                    <td>{{ item.id }}</td>
                                                    <td>{{ item.firstName }}</td>
                                                    <td>{{ item.lastName }}</td>
                                                    <td>{{ item.email }}</td>
                                                    <td>
                                                        <v-icon v-if="item.updateable" class="drei_60-green-text" title="Die E-Mail-Adresse wird noch nicht verwendet">mdi-check-circle</v-icon>
                                                        <v-icon v-if="!item.updateable" class="drei_60-red-text" title="Es gibt bereits einen Account mit dieser E-Mail-Adresse">mdi-alert-circle</v-icon>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <div class="edit-email-stepper-content-actions">
                                            <v-btn class="mr-2" color="warning" outlined @click="setStep(1)">Zurück</v-btn>
                                            <v-btn color="success" outlined @click="setStep(3)">Weiter</v-btn>
                                        </div>
                                    </div>
                                </v-stepper-content>
                                <v-stepper-step step="3" color="success">
                                    Evalanche Store auswählen
                                </v-stepper-step>
                                <v-stepper-content step="3">
                                    <v-layout wrap mb-4>
                                        <v-flex md12 p-2>
                                            <div class="ml-2">
                                                <EvalancheStoreSelect class="mb-2 mt-2" :store="storeId" @change="setStore" />
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap mb-4>
                                        <v-flex md12 pr-1 align-self-end>
                                            <div class="edit-email-stepper-content-actions">
                                                <v-btn color="warning" outlined @click="setStep(2)">Zurück</v-btn>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-stepper-content>
                            </v-stepper>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" outlined @click="abort" :disabled="loading">Abbrechen</v-btn>
                <v-btn outlined class="success" pl-0 pr-0 @click="submit" :loading="loading" :disabled="(checkIfNeedStore ? this.step < 3 : this.step < 2) || !valid || (checkIfNeedStore && this.storeId === '')">Neue Email speichern</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters,
} from 'vuex';
import LabelValue from '@/components/LabelValue.vue';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import EvalancheStoreSelect from '@/components/EvalancheStoreSelect.vue';

const EVALANCHE = 'evalanche';

export default {
    name: 'EditEmail',
    components: {
        EvalancheStoreSelect,
        LabelValue,
        KeineDaten,
    },
    mounted() {
        this.resetState();
        this.initStateAction(this.ssoId);
    },
    props: ['ssoId', 'alternativeBtn', 'isLoading'],
    data() {
        return {
            valid: false,
            showDialog: false,
            tmp: '',
            tippSystemauswahl: 'In den ausgewählten Systemen wird die Änderung der Emailadresse durchgeführt.',
            headers: [{
                text: 'System',
                align: 'left',
                sortable: false,
                value: 'system',
            }, {
                text: '',
                align: 'left',
                sortable: false,
                value: 'scope',
            }, {
                text: 'Vorname',
                align: 'left',
                sortable: false,
                value: 'vorname',
            }, {
                text: 'Nachname',
                align: 'left',
                sortable: false,
                value: 'nachname',
            }, {
                text: 'E-Mail',
                align: 'left',
                sortable: false,
                value: 'email',
            }],
            emailRules: [
                v => !!v || 'Das Feld Emailadresse muss ausgefüllt sein',
                v => (/.+@.+\..+/.test(v) || v.length === 0) || 'Die Emailadresse ist gültig',
                v => v.trim() !== this.emailOld || 'Die neue Emailadresse muss sich von der alten unterscheiden',
            ],
        };
    },
    methods: {
        ...mapActions('customerEditEmail', {
            initStateAction: 'initState',
            changeEmail: 'changeEmail',
            checkEmail: 'checkEmail',
            resetState: 'resetState',
        }),
        ...mapMutations('customerEditEmail', ['setEmail', 'setStore', 'setStep', 'setCheckedEmail']),
        ...mapMutations('snackbar', {
            successMessage: 'success',
        }),
        show() {
            this.resetState();
            this.initStateAction(this.ssoId);
        },
        check() {
            const shortEmailRegex = /(.+)@(.+){2,}\.(.+){2,}/;
            if (shortEmailRegex.test(this.email) && this.valid) {
                this.setCheckedEmail(this.email);
                this.checkEmail();
            }
        },
        abort() {
            this.$emit('close');
            this.resetState();
            this.showDialog = false;
        },
        submit(event) {
            event.preventDefault();
            if (!this.valid) return;
            this.changeEmail().then(() => {
                this.$emit('emailChanged');
                this.showDialog = false;
            }).catch(() => {
                this.showDialog = false;
            });
        },
    },
    computed: {
        ...mapState('customerEditEmail', [
            'loading',
            'loadingSystems',
            'storeId',
            'email',
            'step',
            'checkedEmail',
            'masterdata',
            'systems',
        ]),
        ...mapState('customerEditEmail', {
            emailOld: state => state.masterdata.login,
        }),
        ...mapGetters('customerEditEmail', [
            'hasError',
            'hasInfo',
            'fullname',
        ]),
        checkIfNeedStore() {
            const evalanche = this.systems.filter(s => s.system.toLowerCase() === EVALANCHE)[0];
            if (evalanche) {
                if (evalanche.selected && !evalanche.id) return true;
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
.customer-edit-wizard-step-label {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-direction: row;
}
.v-stepper__label {
    width: 100% !important;
}
 .customer-edit-wizard {
     box-shadow: none;
     -webkit-box-shadow: none;
     margin-top: 10px;
     .v-stepper__content {
         border-left: 1px solid #ebebeb;
         border-right: 1px solid #ebebeb;
         margin: -8px 0px 0px 0px !important;
         padding: 0px 23px 0px 23px;
         &:last-child {
             border-bottom: 1px solid #ebebeb;
             border-bottom-left-radius: 4px;
             border-bottom-right-radius: 4px;
         }
     }
     .v-stepper__step {
         border: 1px solid #ebebeb;
         padding: 10px 16px 10px 16px !important;
         background: #ebebeb;
     }
 }
 .edit-email-stepper-content {
     padding: 16px 0 16px 0;
 }
 .edit-email-stepper-content-actions {
     display: flex;
     justify-content: flex-end;
     margin-top: 10px;
 }
</style>
